import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ReceiveStockInput } from '@models/warehouse.model';
import { warehouseService } from '@services/warehouse';
import { MATERIAL_CATALOG_QUERY_KEY } from './useMaterialCatalog';
import { STOCK_LEVELS_QUERY_KEY } from './useStockLevels';
import { STOCK_TRANSACTIONS_QUERY_KEY } from './useStockTransactions';
import { LOW_STOCK_ITEMS_QUERY_KEY } from './useLowStockItems';

export const useReceiveStock = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['stock', 'receive'],
    mutationFn: async (input: ReceiveStockInput) => {
      return await warehouseService.receiveStock(input);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MATERIAL_CATALOG_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: STOCK_LEVELS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: STOCK_TRANSACTIONS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: LOW_STOCK_ITEMS_QUERY_KEY });
    },
  });
};

export default useReceiveStock;
